import React, { Component } from "react";
import { Form } from "react-form";

import InputText from "components/form-fields/InputText";
import Select from "components/form-fields/Select";

export default class extends Component {
  onSubmit = (data) => {
    this.props.handleFormSubmit(data);
  };

  render() {
    const { defaultValues } = this.props;
    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {(formApi) => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="name"
                    label="Field Name"
                    placeholder="Name"
                  />
                </div>
                <div className="column">
                  <InputText
                    required
                    field="label"
                    label="Label"
                    placeholder="Label"
                  />
                </div>
              </div>
            </div>
            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CompanyProfileType/Form.js